'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for providing permission information on CrmObjects, both user and hubspot defined
 *
 * @param {object} value                          the context value
 * @param {Boolean} value.canView                 whether or not the current user can view the subject record of the current page
 * @param {Boolean} value.canEditSubject          whether or not the current user can edit the subject record of the current page
 * @param {Boolean} value.canDeleteSubject        whether or not the current user can delete the subject record of the current page
 * @param {Boolean} value.readOnly                whether or not the sidebar is in read-only mode
 * @param {String []} value.scopes                array of scopes the current user has
 * @param {String []} value.gates                 array of gates that the current user is ungated for
 */

export const PermissionsContext = /*#__PURE__*/createContext(null);
PermissionsContext.Provider.propTypes = {
  value: PropTypes.shape({
    canView: PropTypes.bool.isRequired,
    canEditSubject: PropTypes.bool.isRequired,
    canDeleteSubject: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    scopes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    gates: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  }).isRequired
};
export const usePermissionsContext = () => useContext(PermissionsContext);